import styled from "@emotion/styled"
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled"
import * as api from "api"
import RatioElement from "common/ElementRatio"
import { useIsDesktop } from "common/MediaQueries"
import { memo, useState } from "react"
import "swiper/css/bundle"
import { Swiper, SwiperSlide } from "swiper/react"
import Shared from "theme/shared"
import ServiceCenterGalleryDialog from "./dialogs/ServiceCenterGalleryDialog"

const Styled = {
  Wrapper: styled.div`
    padding: 10px 15px;
    width: 100%;
  `,
  Swiper: styled(Swiper)`
    width: 100%;
    cursor: pointer;
  `,
  Headline: styled(Shared.Header)`
    text-align: left; // flipped for mui
    margin-top: 0;
    margin-bottom: 15px;
  `,
  RatioElement: styled(RatioElement)`
    margin: 4px 0;
  `,
  Image: styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 3px;
    border: 1px solid ${(p) => p.theme.colors.black};
  `,
  PlayIcon: styled(PlayCircleFilledIcon)`
    color: ${(p) => p.theme.colors.silver};
    font-size: 3rem;
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.9;
  `,
}

Styled.RatioElement.defaultProps = { css: true }

type GalleryProps = { serviceCenter: api.SingleServiceCenter }

const Gallery = ({ serviceCenter }: GalleryProps) => {
  const isDesktop = useIsDesktop()
  const [active, setActive] = useState<number | null>(null)

  if (!serviceCenter.images.length && !serviceCenter.videoUrl.length)
    return null

  return (
    <Styled.Wrapper>
      <Styled.Headline>תמונות מרכז השירות</Styled.Headline>
      <Styled.Swiper
        spaceBetween={8}
        slidesPerView={isDesktop ? 9.2 : 3.2}
        slidesOffsetBefore={2}
        onClick={(swiper) => {
          setActive(swiper.clickedIndex)
        }}
      >
        {serviceCenter.images.map((item, i) => (
          <SwiperSlide
            tabIndex={0}
            role="button"
            key={i}
            style={{ marginBottom: 4 }}
          >
            <Styled.RatioElement ratio={3 / 2} css>
              <Styled.Image
                src={`${item.imageUrl}?width=${Math.floor(375 / 3)}`}
                alt={item.alt}
              />
            </Styled.RatioElement>
          </SwiperSlide>
        ))}
        {serviceCenter.videoUrl.map((item, i) => (
          <SwiperSlide key={i}>
            <Styled.RatioElement ratio={3 / 2} css>
              <Styled.Image
                src={`${
                  serviceCenter.videoThumbnailUrl[i]?.imageUrl
                }?width=${Math.floor(375 / 3)}`}
                alt={serviceCenter.videoThumbnailUrl[i]?.alt}
              />
              <Styled.PlayIcon />
            </Styled.RatioElement>
          </SwiperSlide>
        ))}
      </Styled.Swiper>
      <ServiceCenterGalleryDialog
        active={active}
        images={serviceCenter.images}
        videos={serviceCenter.videoUrl}
        onClose={() => {
          setActive(null)
        }}
      />
    </Styled.Wrapper>
  )
}

export default memo(Gallery)
